module.exports = "images/apple-icon-60x60.9e427003a1fdee071c79d2551d70491d.png";